import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {getNewsApi, removeNews} from '../api/news';
import swal from "sweetalert2";

@Component({
  selector: 'app-all-news',
  templateUrl: './all-news.component.html',
  styleUrls: ['./all-news.component.css']
})
export class AllNewsComponent implements OnInit {

  constructor() { }

  news=[]
  editMode=false;
  rowSelected={}
  loader=true
  ngOnInit() {
    this.getNews()
  }

  async getNews(){
    this.editMode=false
    let result=await getNewsApi()
    this.loader=true

    if(result){
      this.news=result.data.data
      this.loader=false
    }
  }

  selectedRow(row: any) {
    this.rowSelected=row
  this.editMode=true
  }

  refresh() {
    this.getNews()
    document.getElementById("closeNewsModal").click()
    swal(
      'تم انتهاء  العملية بنجاح',
      '',

      'success'
    )
  }

  async deleteNews(id){
    let result=await removeNews(id)

    if(result){
      this.refresh()
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }
  }
  @ViewChild("search")
  public searchElementRef: ElementRef;

  removeSearch() {
    this.searchElementRef.nativeElement.value=""
  }
}
